/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueResponse } from './LeagueResponse';
import {
    LeagueResponseFromJSON,
    LeagueResponseFromJSONTyped,
    LeagueResponseToJSON,
    LeagueResponseToJSONTyped,
} from './LeagueResponse';

/**
 * 
 * @export
 * @interface CreateLeagueResponse
 */
export interface CreateLeagueResponse {
    /**
     * 
     * @type {LeagueResponse}
     * @memberof CreateLeagueResponse
     */
    league: LeagueResponse;
}

/**
 * Check if a given object implements the CreateLeagueResponse interface.
 */
export function instanceOfCreateLeagueResponse(value: object): value is CreateLeagueResponse {
    if (!('league' in value) || value['league'] === undefined) return false;
    return true;
}

export function CreateLeagueResponseFromJSON(json: any): CreateLeagueResponse {
    return CreateLeagueResponseFromJSONTyped(json, false);
}

export function CreateLeagueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeagueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'league': LeagueResponseFromJSON(json['league']),
    };
}

export function CreateLeagueResponseToJSON(json: any): CreateLeagueResponse {
    return CreateLeagueResponseToJSONTyped(json, false);
}

export function CreateLeagueResponseToJSONTyped(value?: CreateLeagueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'league': LeagueResponseToJSON(value['league']),
    };
}

